"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = walkMarkdownTokens;

function walkMarkdownTokens(tokens, walker) {
  return tokens.map(function (token) {
    if (token) {
      var nextToken = walker(token);

      if (nextToken.children) {
        nextToken.children = walkMarkdownTokens(nextToken.children, walker);
      }

      return nextToken;
    }

    return token;
  });
}